module.exports = __webpack_public_path__ + "static/media/mobile_trending.9878e9c0.png";


//////////////////
// WEBPACK FOOTER
// ../images/screenshots/mobile_trending.png
// module id = 659
// module chunks = 0